import React, { Component } from 'react'
import Styles from './WorkflowDialogBox.module.css'
import WorkflowDialogField from './WorkflowDialogField'
import WorkflowDialogSummaryItem from './WorkflowDialogSummaryItem'
import WorkflowConfirmationDialog from './WorkflowConfirmationDialog'
import Axios from '../../components/Axios'
import Spinner from '../../components/Spinner/Spinner'
import * as z from "zod";
import validator from "validator";
import axios from 'axios'

class WorkflowDialogBox extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentScreenIndex: 1,
            prevScreenIndex: 1,
            nextScreenIndex: 1,
            IsSummaryScreen: false,
            is_submitted: false,
            maxScreenIndex: 1,
            dialogtitle: '',
            screentitle: '',
            fields: [],
            values: [],
            wfdata_ProgramName: undefined,
            files: [],
            fileNames: [],
            showConfirmation: false,
            confDialog: '',
            userEmail: '',
            is_edit: this.props.is_edit,
            error: '',
            isSAP: false,
            hasFileEdits: false,
            Tin: this.props.tin
        };

        this.EnableAddressEdit = this.EnableAddressEdit.bind(this);
        this.UpdateVOtherState = this.UpdateVOtherState.bind(this);
        this.funcMap = {
            'EnableAddressEdit': this.EnableAddressEdit,
            'UpdateVOtherState': this.UpdateVOtherState

        };
    }
    componentDidMount() {
        let json = {};
        json.user = this.props.user;
        json.org_id = this.props.org_id;
        json.is_edit = this.props.is_edit;
        json.instance_id = this.props.id;
        var isSap = false;

        if (this.props.isSAP && this.props.isSAP == true) {
            isSap = true;
        }

        let confDialog =
            (<WorkflowConfirmationDialog org_id={this.props.org_id} title={'Event Submitted'} firstline={'The E&D event  has been submitted for approval.'} secondline={''} close={this.closeConf.bind(this)} approver={this.props.user} />)

        Axios('/api/v1/workflow/get-latest-workflow', json, (data) => {


            this.setState({ data: data, confDialog: confDialog, userEmail: this.props.user, isSAP: isSap });

            this.setDefaults(data);

            this.buildUI(this.state.currentScreenIndex, false, false, true);

        });


    }
    setDefaults(data) {

        var fileArr = [];

        data.Nodes.forEach(node => {
            node.Fields.forEach(field => {
                if (field.DefaultValue && field.DefaultValue != '') {
                    this.setState({ [field.FieldName]: field.DefaultValue });
                }

                //if (field.DataType == 'datetime') {
                //    this.setState({ [field.FieldName]: new Date() });
                //}
            })

        });
        

    }
    buildUI(idx, wiggle, overideDisabled, addDefaultFiles) {
        var fields = [];
        var wf = this.state.data;

        var title = wf.WorkflowName;
        var screenTitleTemp = '';
        var next = 1;
        var prev = 1;
        var wiggleTemp = false;
        var controlVal;
        var currentIndex = idx;
        var isSummaryScreen = false;
        var isRequired = false;
        var isDisabled = false;
        var pn = this.state["wfdata_ProgramName"];

        var fileArr = [];
        var fileDisplay = [];
        var fileNames = [];

        fileArr = this.state.files;

        // alert( ' overideDisabled: ' + overideDisabled);
        if (addDefaultFiles) {
            
            if (wf.Files) {
                wf.Files.forEach((element) => {

                    var object = { "title": element.WORKFLOW_FILE_NAME, "name": element.FILE_NAME, "file": null }

                    fileArr.push(object);

                });
            }
            

        }

        wf.Nodes.forEach(node => {

            if (idx == node.NodeIndex) {
                screenTitleTemp = node.NodeName;
                isRequired = false;
                prev = node.PrevIndex;
                next = node.NextIndex;
                var arrFileNames = [];
         

                if (node.IsSummaryScreen) {
                    isSummaryScreen = true
                } else {
                    node.Fields.forEach(field => {

                        controlVal = this.state[field.FieldName];

                        if (field.DataType == "fileuploadgroup") {


                           // var arrTemp = [];
                           // arrTemp = this.state.files;


                           

                           //arrTemp.forEach((element) => {
                           //     var object = { "title": element.title, "name": element.name, "file": element.file }
                           //   //  fileDisplay.push(<div className={Styles.filerow}> <div className={Styles.fileleft}>{element.WORKFLOW_FILE_NAME} </div> <div className={Styles.fileright}>{element.FILE_NAME}</div><br /></div>);
                           //     fileArr.push(object);

                           // });
                            
                           

                           
                        }
                        

                        isRequired = field.IsRequired;
                        isDisabled = field.IsDisabled;

                        if (overideDisabled) {
                            isDisabled = false;
                        }

                        fields.push(<WorkflowDialogField
                            pn={pn}
                            disabled={isDisabled}
                            field={field}
                            key={field.FieldName}
                            action={this.callFieldAction.bind(this)}
                            program_name={this.title}
                            required={isRequired}
                            setValue={this.setControlValue.bind(this)}
                            setDateValue={this.setDateValue.bind(this)}
                            setCheckValue={this.setCheckValue.bind(this)}
                            setUploadFile={this.setUploadFile.bind(this)}
                            value={controlVal}
                            fileArr={fileArr}
                           
                        />);

                    })

                }

            }

        })

        if (isSummaryScreen) {
            var name = "";
            var value = "";
            var isSap = "false";

            if (this.props.isSAP && this.props.isSAP == true) {
                isSap = "true";
            }

          //  fields.push(<WorkflowDialogSummaryItem key={'ISSAP'} name={'IS SAP'} value={isSap} datatype={'text'} />);

            wf.Nodes.forEach(node => {
                node.Fields.forEach(field => {

                    if (field.DataType == 'datetime') { value = new Date(this.state[field.FieldName]).toLocaleDateString('en-US') } else { value = this.state[field.FieldName]; }

                    if (field.DataType != 'fileupload' && field.DataType != 'fileuploadgroup') {
                        fields.push(<WorkflowDialogSummaryItem key={field.FieldName} name={field.FieldTitle} value={value} datatype={field.DataType} />);
                    }

                })

            })



            var fileArr = this.state.files;
            var stringarr = "";
            fileArr.forEach((node) =>  {

               // console.log("s");
                fields.push(<WorkflowDialogSummaryItem key={node.name} name={node.name} value={node.name} />);

            });


        }

        this.setState({ fields: fields, dialogtitle: title, screentitle: screenTitleTemp, currentScreenIndex: idx, nextScreenIndex: next, prevScreenIndex: prev, IsSummaryScreen: isSummaryScreen, files: fileArr });
    }
    movePrev() {

        var idx = this.state.currentScreenIndex;
        var previdx = this.state.prevScreenIndex;

        if (idx != previdx && idx != 1) {
            this.buildUI(previdx, false, false, false);
        }
    }
    moveNext() {

        var idx = this.state.currentScreenIndex;
        var nextidx = this.state.nextScreenIndex;
        var isValid = false;

        switch (idx) {
        case 1: //Initial Screen
            isValid = this.validateInitialScreen();
            break;
        case 2: //Part 1
            isValid = this.validatePart1();
            break;
        case 3: //Part 2
            isValid = this.validatePart2();
            break;
        case 4: //Part 3
            isValid = this.validatePart3();
            break;
        case 5: //Part 4
            isValid = this.validatePart4();
            break;
        default:
            //do nothing (isValid = false)
        }

        if (isValid) {

            if (idx != nextidx) {
                this.buildUI(nextidx, false, false, false);
            }

            // this.buildUI(nextidx, false);
        }
        else {
            this.buildUI(idx, true, false, false);
        }


    }
    closeConf() {

        this.setState({ showConfirmation: false });
        this.props.close();
    }
    submit() {

        var isValid = this.validatePart5();
        if (!isValid) {
            this.setState({ is_submitted: false, error: "Final validation check failed.  Please contact BIS."});
            return;
        };

        let post_json = {};
        var jsonString = this.state;
        let arr = [];

        Object.keys(this.state).map(key => {

            if (key.startsWith('wfdata_')) {
                arr.push(key + "=" + this.state[key]);
            }

        })

        var tinNew = this.state["wfdata_TIN"];
        var tinOld = this.state.Tin;

        let startDate = new Date(this.state["wfdata_StartDT"]);
        let endDate = new Date(this.state["wfdata_EndDT"]);
        let orgname = this.state["wfdata_OrgName"];
        let uname = this.props.user.email;
        let programname = this.state["wfdata_ProgramName"];
        let amt = this.state["wfdata_Amount"];

        post_json.user = this.props.user;
        post_json.Json = arr.join("|");

        post_json.approvaljson = '';

        post_json.OrgName = orgname;
        post_json.OrgID = this.props.org_id;
        
        post_json.ProgramName = programname;
        post_json.Amount = amt;
        post_json.PaymentMethod = this.state["wfdata_PaymentMethod"];
        post_json.StartDT = startDate;
        post_json.EndDT = endDate;
        post_json.WFID = this.props.id;
        post_json.IsEdit = this.state.is_edit;

        var editRemit = this.state["wfdata_EditRemit"];
        post_json.IsRemitAddress = editRemit;
        post_json.IsSAP = this.state.isSAP ? 1 : 0;
        post_json.TIN = tinNew;
        
        Axios('/api/v1/workflow/submit-workflow', post_json, (data) => {

            var me = this;
            var fileArr = this.state.files;

            var formattedStartDT = new Date(post_json.StartDT).toLocaleDateString();
            var formattedEndDT = new Date(post_json.EndDT).toLocaleDateString();

            const formData = new FormData();

            formData.append('wfid', data);
            formData.append('orgid', this.props.org_id);
          
            var onefile = false;

            fileArr.forEach((file) => {

                if (file.file != null) {
                    onefile = true;
                    var filename = file.name;
                    formData.append('file', file.file, filename);
                }

            });
            if (onefile == true) {
                axios.post('/api/v1/workflow/upload_workflow_files', formData)
                    .then(function (response) {
                        me.setState({ showConfirmation: true });
                    })
                    .catch(function (e) {
                        console.error("An error occurred uploading files to the API upload_workflow_files method:", e.message);
                        me.setState({ error: "The attached files failed to upload.  Please email exhibits.displays@incyte.com to notify."});
                        return;
                     });
            } else {         
                me.setState({ showConfirmation: true });
            }
            let approver_json = {};
            approver_json.workflow_id = data;
            approver_json.user = this.props.user;

            axios.post('/api/v1/workflow/get-next-two-approvers', approver_json)
                .then(function (approverData) {

                    let email_json = {};

                    let approverName = approverData.data.current_approver_name;
                    let approverEmail = approverData.data.current_approver_email;
                    let requestor = approverData.data.requestor_email;
                 

                    let sysNote = "<br/><p><i><b>Note:</b> This is system generated mail. Please do not reply.  If you require any further assistance, please email exhibits.displays@incyte.com.</i></p>";
                    let wflink = "<br/><p>Click on the following link to access the application: <a href='https://incyte-mdm-portal.bellcyn.com/workflow?id={data}'>Exhibits & Displays Approval.</a></p>";

                    email_json.to = approverEmail;
                    email_json.subject = "An exhibit and display request has been submitted";



                    email_json.body =  "<p>An exhibit and display request has been submitted from " + requestor + " that requires Your approval.  Please review and respond within three business days. </p>" +
                        "<br /> <b>ORG NAME: </b>" +
                        orgname + "<br /> <b>PROGRAM NAME: </b> " +
                        programname + "<br /> <b>AMOUNT: </b> $" +
                        amt + "<br /> <b>DATE: </b> " +
                        formattedStartDT + " - " +
                        formattedEndDT + "<br /><br />" + wflink + sysNote;

                    axios.post('/api/v1/workflow/send-email', email_json)
                        .then(function (response) {


                        })
                        .catch(function (response) {

                            //  alert(response);
                        });

                    console.log('email sent' + approverEmail);

                })
                .catch(function (response) { });

            if (editRemit == "true" || !this.state.isSAP ) {

                let ops_json = {};
                ops_json.team = this.props.user.team;
                let optionalTXT = "";
                
                if (editRemit == "true") {
                    optionalTXT = "This exhibit was outside of the Incyte domain and the remit address was effected.";

                }

                if (!this.state.isSAP) {
                    optionalTXT = optionalTXT + "  This exhibit was outside of the Incyte SAP domain.";

                }

                axios.post('/api/v1/workflow/get-market-ops', ops_json)
                    .then(function (opsData) {

                        let email_jsonOPS = {};
                        let email_jsonED = {};

                        let approverNameOPS = opsData.data.market_ops_name;
                        let approverEmailOPS = opsData.data.market_ops_email;
                        
                        email_jsonOPS.to = approverEmailOPS;
                        email_jsonOPS.subject = "An exhibit and display request has been submitted & requires attention";
                        email_jsonOPS.body = "<p>An exhibit and display request has been submitted that requires your review. Please review and respond within three business days. </p>" +
                            "<br /><p>" + optionalTXT + " </p>" +
                            "<br /> <b>E&D Requestor: </b>" + uname +
                            "<br /> <b>ORG NAME: </b>" + orgname +
                            "<br /> <b>PROGRAM NAME: </b>" + programname +
                            "<br /> <b>AMOUNT: </b> $" + amt + "<br /> <b>DATE: </b> " +
                            formattedStartDT + " - " + formattedEndDT + "<br /><br />" +
                            "<br/><p><i><b>Note:</b> This is system generated mail. Please do not reply.  If you require any further assistance, please email exhibits.displays@incyte.com.</i></p>" +
                            "<br/><p>Click on the following link to access the application: <a href='https://incyte-mdm-portal.bellcyn.com/workflow?id={data}'>Exhibits & Displays Approval.</a></p>";

                        console.log('email sent' + approverEmailOPS);

                        axios.post('/api/v1/workflow/send-email', email_jsonOPS)
                            .then(function (responseOPS) {


                            })
                            .catch(function (responseOPS) {

                                //  alert(response);
                            });
                       

                        email_jsonED.to = "exhibits.displays@incyte.com";
                        email_jsonED.subject = "An exhibit and display request has been submitted & requires attention";
                       
                        email_jsonED.body = "<p>An exhibit and display request has been submitted that requires your review. Please review and respond within three business days. </p>" +
                            "<br /><p>" + optionalTXT + " </p>" +
                            "<br /> <b>E&D Requestor: </b>" + uname +
                            "<br /> <b>ORG NAME: </b>" + orgname +
                            "<br /> <b>PROGRAM NAME: </b>" + programname +
                            //"<br /> <b>AMOUNT: </b> $" + amt + "<br /> <b>DATE: </b> " +
                            formattedStartDT + " - " + formattedEndDT + "<br /><br />" +
                            "<br/><p><i><b>Note:</b> This is system generated mail. Please do not reply.  If you require any further assistance, please email exhibits.displays@incyte.com.</i></p>" +
                            "<br/><p>Click on the following link to access the application: <a href='https://incyte-mdm-portal.bellcyn.com/workflow?id={data}'>Exhibits & Displays Approval.</a></p>";


                        axios.post('/api/v1/workflow/send-email', email_jsonED)
                            .then(function (responseOPS) {


                            })
                            .catch(function (responseOPS) {

                                //  alert(response);
                            });

                        console.log('email sent exhibits.displays@incyte.com');

                    })
                    .catch(function (responseOPS) { });
            }    

        });

        if (tinNew !== tinOld ) {

                let json = {}

                json.REQUEST_TYPE = "Update HCO TIN";
                json.REQUESTOR_NAME = this.props.user.userName;
                json.PROF_ID = '';
                json.REQUESTOR_TEAM = this.props.user.team;
                json.REQUEST_NOTE = ''  //this.state.REQUEST_NOTE''
                json.TIN = tinNew;
                json.ORG_NAME = this.state["wfdata_OrgName"];
                json.ORG_ID = this.props.org_id;
                Axios('/api/v2/global/change-request', json, (data) => { })

        }


    }
    setControlValue(target, action, disabled) {

        this.setState({ [target.name]: target.value });

        if (action) {
            this.callFieldAction(action, target);
        }


    }
    setCheckValue(target, action, value) {

        this.setState({ [target.name]: value });

        if (action) {
            this.callFieldAction(action, target);
        }


    }
    setDateValue(name, date) {

        this.setState({ [name]: date });

    }
    setUploadFile(fileInfoList) {
        var fileArr = this.state.files;
        var newArr = [...this.state.files];

        for (let fileIndex = 0; fileIndex < fileInfoList.length; fileIndex++) {
            let fileInfo = fileInfoList[fileIndex]
            var new_object = { "title": fileInfo.title.toUpperCase(), "name": fileInfo.filename, "file": fileInfo.file }
    
            let matchingFileIndex = fileArr.findIndex(file => {
                if (fileInfo.title.toUpperCase() == "OTHER") {
                    return file.name.toUpperCase() == fileInfo.filename.toUpperCase()
                } else {
                    return file.title.toUpperCase() == fileInfo.title.toUpperCase()
                }
            })
            if (matchingFileIndex != -1) {
                newArr[matchingFileIndex].file = fileInfo.file
                newArr[matchingFileIndex].name = fileInfo.filename
            } else {
                newArr.push(new_object)
            }
        }

        this.setState({ files: newArr });
        return newArr;
    }
    EnableAddressEdit(target) {
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_add").IsDisabled = !target.checked
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_city").IsDisabled = !target.checked
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_state").IsDisabled = !target.checked
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_zip").IsDisabled = !target.checked

        this.buildUI(this.state.currentScreenIndex, false, false, false);

    }
    UpdateVOtherState(target) {
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_vother").IsRequired = target.value === "Other"
        this.state.data.Nodes[this.state.data.CurrentNodeIndex].Fields.find(f => f.FieldName === "wfdata_vother").IsDisabled = target.value !== "Other"
        this.setState({ data: this.state.data })
        this.buildUI(this.state.currentScreenIndex, false, false, false)
    }
    callFieldAction(ActionName, target) {
        var content;
        const method = this.funcMap[ActionName];
        if (typeof method === 'function') {
            content = method(target);
        }
        return content;
    }
    exportData(id) {

    }

    validateInitialScreen() {

        var isValid = false;

        const initialScreenSchema = z.object({
            region: z.string("Region is required"),
            priority: z.string("Priority is required"),
            exhibitType: z.string("Exhibit Type is required"),
            organizationName: z.string("Organization Name is required"),
            programActivityTitle: z.string("Program/Activity Title is required"),
            tin: z.string("TIN is required")
                .length(9, { message: 'TIN is required and must be 9 characters' }),
            crmMdmInstitutionId: z.string("CRM/MDM Institution Id is required"),
            country: z.string("Country is required"),
            contactPhone: z.string("Contact Phone is required")
                .refine(validator.isMobilePhone, { message: 'Please provide Contact Phone in the correct format' }),
            contactEmail: z.string()
                .refine(validator.isEmail, { message: 'Please provide Contact Email in the correct format' })
                .optional(),
        });

        try {

            initialScreenSchema.parse(
                { 
                    region: !this.state["wfdata_Region"] ? undefined : this.state["wfdata_Region"],
                    priority: !this.state["wfdata_Priority"] ? undefined : this.state["wfdata_Priority"],
                    exhibitType: !this.state["wfdata_ExhibitType"] ? undefined : this.state["wfdata_ExhibitType"],
                    organizationName: !this.state["wfdata_OrgName"] ? undefined : this.state["wfdata_OrgName"],
                    programActivityTitle: !this.state["wfdata_ProgramName"] ? undefined : this.state["wfdata_ProgramName"],
                    tin: !this.state["wfdata_TIN"] ? undefined : this.state["wfdata_TIN"],
                    crmMdmInstitutionId: !this.state["wfdata_CRM"] ? undefined : this.state["wfdata_CRM"],
                    country: !this.state["wfdata_Country"] ? undefined : this.state["wfdata_Country"],
                    contactPhone: !this.state["wfdata_ContactPhone"] ? undefined : this.state["wfdata_ContactPhone"],
                    contactEmail: !this.state["wfdata_ContactEmail"] ? undefined : this.state["wfdata_ContactEmail"],
                });

            //console.log('Validation successful for initial screen.');
            isValid = true;
            this.setState({ error: '' });

        } catch (e) {

            //console.error('Validation failed for initial screen:', e);
            this.setState({ error: e.issues.map(issue => issue.message).join(',') });

        }

        return isValid;
    }

    validatePart1() {

        var isValid = false;

        const part1Schema = z.object({
            address: z.string("Remit Address is required"),
            city: z.string("Remit City is required"),
            state: z.string("Remit State is required"),
            zip: z.string("Remit Zip is required"),
            venueName: z.string("Venue Name is required"),
            venueAddress: z.string("Venue Address is required"),
            venueCity: z.string("Venue City is required"),
            venueState: z.string("Venue State is required"),
            venueType: z.string("Venue Type is required"),
            otherTypeTest: z.string()
                .optional(),
            venueUrl: z.string()
                .refine(validator.isURL, { message: 'Please provide a valid URL/Web Address.' })
                .optional(),
        });

        try {

            part1Schema.parse(
                { 
                    address: !this.state["wfdata_add"] ? undefined : this.state["wfdata_add"],
                    city: !this.state["wfdata_city"] ? undefined : this.state["wfdata_city"],
                    state: !this.state["wfdata_state"] ? undefined : this.state["wfdata_state"],
                    zip: !this.state["wfdata_zip"] ? undefined : this.state["wfdata_zip"],
                    venueName: !this.state["wfdata_vname"] ? undefined : this.state["wfdata_vname"],
                    venueAddress: !this.state["wfdata_vadd"] ? undefined : this.state["wfdata_vadd"],
                    venueCity: !this.state["wfdata_vcity"] ? undefined : this.state["wfdata_vcity"],
                    venueState: !this.state["wfdata_vstate"] ? undefined : this.state["wfdata_vstate"],
                    venueType: !this.state["wfdata_vtype"] ? undefined : this.state["wfdata_vtype"],
                    otherTypeTest: !this.state["wfdata_vother"] ? undefined : this.state["wfdata_vother"],
                    venueUrl: !this.state["wfdata_vurl"] ? undefined : this.state["wfdata_vurl"],
                });

            //console.log('Validation successful for Part 1.');
            isValid = true;
            this.setState({ error: '' });

        } catch (e) {

            //console.error('Validation failed for Part 1:', e);
            this.setState({ error: e.issues.map(issue => issue.message).join(',') });

        }

        return isValid;
    }

    validatePart2() {

        var isValid = false;

        const part2Schema = z.object({
            displayStartDate: z.coerce.date("Display Start Date is required"),
            displayEndDate: z.coerce.date("Display End Date is required"),
            amount: z.coerce.number("Amount is required"),
            paymentMethod: z.string("Payment Method is required"),
            displayPanelType: z.string("Display Panel Type is required"),
            variousDisplayLevels: z.coerce.boolean()
                .optional(),         
            explanationOfLevels: z.string()
                .optional(),
        })
        .superRefine((data, ctx) => {
            if (data.displayEndDate < data.displayStartDate) {
                ctx.addIssue({
                    code: "endDateBeforeStartDate",
                    message: `The End Date cannot be before Start Date`,
                    input: data,
                });
            }
            if (data.amount > 10000 && data.paymentMethod == "Credit") {
                ctx.addIssue({
                    code: "paymentMethodHighAmount",
                    message: `Payment Method must be CHECK for all amounts above $10,000`,
                    input: data,
                });
            }
            if (data.variousDisplayLevels && !data.explanationOfLevels) {
                ctx.addIssue({
                    code: "variousDisplayLevelsTrueReqExp",
                    message: `Please provide an explanation for the various levels.`,
                    input: data,
                });
            }
        });

        try {

            part2Schema.parse(
                { 
                    displayStartDate: !this.state["wfdata_StartDT"] ? undefined : this.state["wfdata_StartDT"],
                    displayEndDate: !this.state["wfdata_EndDT"] ? undefined : this.state["wfdata_EndDT"],
                    amount: !this.state["wfdata_Amount"] ? undefined : this.state["wfdata_Amount"],
                    paymentMethod: !this.state["wfdata_PaymentMethod"] ? undefined : this.state["wfdata_PaymentMethod"],
                    displayPanelType: !this.state["wfdata_PanelType"] ? undefined : this.state["wfdata_PanelType"],
                    variousDisplayLevels: !this.state["wfdata_Levels"] ? false : this.state["wfdata_Levels"],
                    explanationOfLevels: !this.state["wfdata_LevelExplaination"] ? undefined : this.state["wfdata_LevelExplaination"],
                });

            //console.log('Validation successful for Part 2.');
            isValid = true;
            this.setState({ error: '' });

        } catch (e) {

            //console.error('Validation failed for Part 2:', e);
            this.setState({ error: e.issues.map(issue => issue.message).join(',') });

        }

        return isValid;
    }

    validatePart3() {

        var isValid = false;

        const part3Schema = z.object({
            specialty: z.string("Specialty is required"),
            otherSpecialty: z.string()
                .optional(),
            numberOfDisplayParticipants: z.coerce.number("Number of Display Participants is required"),
            numberOfAttendees: z.coerce.number("Number of Attendees is required"),
            geographyOfAttendees: z.string("Geography of Attendees is required"),
            durationTimeOfDisplay: z.coerce.number("Duration Time of Display (Hours) is required"), //in hours
            durationNote: z.string("Duration Note is required"),
        })
        .superRefine((data, ctx) => {
            if (data.specialty == 'Other Specialty' && !data.otherSpecialty) {
                ctx.addIssue({
                    code: "otherSpecialtyRequiredWhenSelected",
                    message: `Please specify the other specialty`,
                    input: data,
                });
            }
        });

        try {

            part3Schema.parse(
                { 
                    specialty: !this.state["wfdata_Specialty"] ? undefined : this.state["wfdata_Specialty"],
                    otherSpecialty: !this.state["wfdata_OtherSpecialty"] ? undefined : this.state["wfdata_OtherSpecialty"],
                    numberOfDisplayParticipants: !this.state["wfdata_NumberPart"] ? undefined : this.state["wfdata_NumberPart"],
                    numberOfAttendees: !this.state["wfdata_NumberAttend"] ? undefined : this.state["wfdata_NumberAttend"],
                    geographyOfAttendees: !this.state["wfdata_Geo"] ? undefined : this.state["wfdata_Geo"],
                    durationTimeOfDisplay: !this.state["wfdata_Duration"] ? undefined : this.state["wfdata_Duration"],
                    durationNote: !this.state["wfdata_DurationNote"] ? undefined : this.state["wfdata_DurationNote"],
                });

            //console.log('Validation successful for Part 3.');
            isValid = true;
            this.setState({ error: '' });

        } catch (e) {

            //console.error('Validation failed for Part 3:', e);
            this.setState({ error: e.issues.map(issue => issue.message).join(',') });

        }

        return isValid;
    }

    validatePart4() {

        var isValid = false;

        const fileUploadSchema = z.array(z.object({
            title: z.string()
        }));
    
        const part4Validator = fileUploadSchema.refine(
                (files) => files.some(file => file.title === 'W9'),
                    {
                        message: 'W9 is required',
                    }
                );

        try {

            part4Validator.parse(this.state.files);
            //console.log('Validation successful for Part 4 / files.');
            isValid = true;
            this.setState({ error: '' });

        } catch (e) {

            //console.error('Validation failed for Part 4 / files:', e);
            this.setState({ error: e.issues[0].message });

        }

        return isValid;
    }

    validatePart5() {

        var isValid = false;

        var initialScreenIsValid = this.validateInitialScreen();
        var part1IsValid = this.validatePart1();
        var part2IsValid = this.validatePart2();
        var part3IsValid = this.validatePart3();
        var part4IsValid = this.validatePart4();

        isValid = (initialScreenIsValid && part1IsValid && part2IsValid && part3IsValid && part4IsValid);

        return isValid;
    }

    render() {

        return (

            <div className={Styles.editScreen}>
                <div className={Styles.title}>
                    <div></div>
                    <div className={Styles.TitleText}>{this.state.dialogtitle}</div>
                    <div className={Styles.close} style={{visibility: this.state.is_submitted ? "hidden" : "inherit"}} onClick={() => {
                        if (!this.state.is_submitted) this.props.close()
                    }}><span aria-hidden="true">×</span></div>
                </div>
                <div className={Styles.body}>

                    <div className={Styles.screenTitle}>{this.state.screentitle}</div>

                    {this.state.showConfirmation ? this.state.confDialog : ''}
                    <div className={this.state.IsSummaryScreen ? Styles.red : Styles.blue}>

                        {this.state.fields}

                    </div>
                    <div className={Styles.error}>{ this.state.error}</div>

                </div>
                <div className={Styles.buttonRow}>
                    <div id={this.state.is_submitted ? Styles.disable : Styles.submit} onClick={() => {
                        if (!this.state.is_submitted) this.props.close();
                    }}>CANCEL</div>
                    <div id={this.state.is_submitted || this.state.prevScreenIndex == this.state.currentScreenIndex ? Styles.disable : Styles.submit} onClick={() => {
                        if (!this.state.is_submitted) this.movePrev();
                    }}>PREV</div>
                    <div id={!this.state.is_submitted && this.state.nextScreenIndex > this.state.currentScreenIndex ? Styles.submit : Styles.disable} onClick={() => {
                        if (!this.state.is_submitted) this.moveNext();
                    }}>NEXT</div>
                    <div id={this.state.IsSummaryScreen || this.state.nextScreenIndex == this.state.currentScreenIndex ? Styles.submit : Styles.disable} onClick={() => {

                        if (this.state.IsSummaryScreen && this.state.is_submitted == false) {
                            this.setState({ is_submitted: true });
                            this.submit();
                        }
                    }}>{this.state.is_submitted ? <Spinner className={Styles.workflowSpinner}></Spinner> : "SUBMIT"}</div>
                </div>
            </div>


        )
    }

}
export default WorkflowDialogBox;







